module.exports = __webpack_public_path__ + "media/images/i-futur-f76e336461f3d96b5e23a1ab8da64afa.png";